import { Progress, useMantineTheme } from '@mantine/core';
import { useMemo } from 'react';

import { useIsMobile } from '~/domains/common/hooks/mediaQueries';

import type { SectionKeyItem } from '../../context/utils/getAllSectionKeys';

export function SectionsProgressBar({
  currentSectionKey,
  allSectionsKeys,
  isFinal,
}: {
  currentSectionKey: SectionKeyItem;
  allSectionsKeys: SectionKeyItem[];
  isFinal?: boolean;
}) {
  const theme = useMantineTheme();
  const isMobile = useIsMobile();

  const progressValue = useMemo(() => {
    if (isFinal) return 100;
    if (!allSectionsKeys && allSectionsKeys.length === 0) return 0;

    const currentSectionIndex = currentSectionKey
      ? allSectionsKeys.findIndex((sectionKey) => sectionKey.key === currentSectionKey.key)
      : -1;
    return ((currentSectionIndex + 1) / allSectionsKeys.length) * 100;
  }, [allSectionsKeys, currentSectionKey, isFinal]);

  return (
    <Progress
      value={progressValue}
      color="splash.5"
      styles={{
        root: {
          background: theme.colors.gray2[1],
        },
        bar: {
          transition: 'width 1s ease-in-out',
        },
      }}
      size={isMobile ? 'xs' : 'md'}
    />
  );
}
